import request from 'superagent/lib/client';
import apiUrlProvider from './ApiURL';

function getCredentialsFromLocalStorage() {
    return JSON.parse(localStorage.getItem('scality-credentials')) || '';
}

export default {

    // Get all groups
    getGroups: (nbItems, marker) => {
        const credentials = getCredentialsFromLocalStorage();
        const markerParam = marker || '';

        return new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}/iam/groups/${nbItems}/` +
                `${markerParam}`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Get details on one group
    getGroup: (groupname, nbItems, marker) => {
        const credentials = getCredentialsFromLocalStorage();
        const markerParam = marker || '';
        const urlPath = `/iam/group/${groupname}/${nbItems}/${markerParam}`;

        return new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}${urlPath}`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // List the groups of a specific user
    listUserGroups: username => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}/iam/group/user/${username}`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Create a new group
    createGroup: groupname => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/iam/group`)
                .set('x-access-token', credentials)
                .send({
                    groupname,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Delete group
    deleteGroup: groupname => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .delete(`${apiUrlProvider.apiUrl()}/iam/group/${groupname}`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Add user to group
    addUser: (username, groupname) => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/iam/group/adduser`)
                .set('x-access-token', credentials)
                .send({
                    username,
                    groupname,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Delete user from group
    deleteUser: (groupname, username) => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .delete(
                  `${apiUrlProvider.apiUrl()}/iam/group/`
                  + `${groupname}/${username}`
                )
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },


};



/** WEBPACK FOOTER **
 ** ./src/utils/GroupsAPI.js
 **/